<div class="identi-page-wrapper pb-5">
  <app-product-hero
    [level]="productLevels.Level3"
    title="identifind"
    subtitle="Never lose your pet again with real time PitPat GPS tracking and award-winning activity monitoring. <br> Combined with identibase’s unique pet finder services, you’ll have ultimate peace of mind."
    badgeUri="/assets/images/identibase/identiFind/hero-badge.svg"
    (onBuyClick)="buyIdentiFindSubscription()"
    (onCompareClick)="compareClick()"
    [compareVisible]="buyButtonVisible"
    [levelsVisible]="true"
    [buyHidden]="!buyButtonVisible"
    [disabled]="!hasIdentiFindOption && isAuthenticated"
  ></app-product-hero>

  <div class="row py-4 light-background">
    <div class="col-12 text-center px-3">
      <div
        class="row row-cols-lg-5 row-cols-md-5 row-cols-2 mt-1 px-lg-5 px-md-3 px-sm-1 d-flex justify-content-center"
      >
        <div class="col text-center my-2">
          <img
            class="feature-icon"
            src="/assets/images/identibase/identiFind/globe-icon.svg"
            alt="globe-icon"
          />
          <h6 class="mt-lg-3 mt-md-3 mt-sm-2">
            Avoid losing your pet <br> with GPS tracking
          </h6>
        </div>
        <div class="col text-center my-2">
          <img
            class="feature-icon"
            src="/assets/images/identibase/identiFind/live-location-badge.svg"
            alt="live-location-badge"
          />
          <h6 class="mt-lg-3 mt-md-3 mt-sm-2">Live location from any distance</h6>
        </div>
        <div class="col text-center my-2">
          <img
            class="feature-icon"
            src="/assets/images/identibase/identiFind/activity-monitoring-badge.svg"
            alt="activity-monitoring-badge"
          />
          <h6 class="mt-lg-3 mt-md-3 mt-sm-2">Award-winning activity monitoring</h6>
        </div>
        <div class="col text-center my-2">
          <img
            class="feature-icon"
            src="/assets/images/identibase/identiAlert/box-approved.svg"
            alt="helpline"
          />
          <h6 class="mt-lg-3 mt-md-3 mt-sm-2">
            Includes all the features of identialert
          </h6>
        </div>
      </div>
      <button
        *ngIf="buyButtonVisible"
        (click)="buyIdentiFindSubscription()"
        type="button"
        class="btn blue-button mt-lg-4 mt-md-3 mt-sm-2"
        [disabled]="!hasIdentiFindOption && isAuthenticated"
      >
        Buy now
      </button>
    </div>
  </div>

  <div class="row pt-5 mid-background">
    <div class="col-6 offset-6 me-0 pe-0 mb-0 pb-0 img-col">
      <img
        class="sms-alert-img"
        src="/assets/images/identibase/identiFind/identifindTracker.png"
        alt="identifind-tracker"
      />
    </div>
    <div class="col">
      <div class="container px-5">
        <div class="row mb-3">
          <div class="col-12">
            <h3>Find your dog with a PitPat dog GPS tracker</h3>
            <h5>
              Your identifind plan comes with a PitPat dog GPS tracker, so
              you can have the peace of mind that you can find your dog if they
              ever run off.
            </h5>
          </div>
        </div>
        <div class="row mb-5">
          <div class="col-sm-12 col-md-6 col-lg-6 my-2">
            <iframe
              class="video"
              [src]="safeURL"
              frameborder="0"
              allowfullscreen
            ></iframe>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-6 my-2">
            <img
              class="image"
              src="/assets/images/identibase/identiFind/pitpat.jpg"
              alt="pitpat"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <span *ngIf="desktopViewVisible; else mobileSubscriptionTable">
    <app-subscription-table-desktop
      id="subscription-table"
      [identibasePlusButtonLabel]="'Learn more'"
      [identialertButtonLabel]="'Learn more'"
      [identifindButtonLabel]="'Buy now'"
      [findHighlighted]="true"
      [buyButtonDisabled]="!hasIdentiFindOption && isAuthenticated"
      [buyButtonVisible]="buyButtonVisible"
      (identitableButtonClicked)="onIdentitableButtonClicked($event)"
    ></app-subscription-table-desktop>
  </span>
  <ng-template #mobileSubscriptionTable>
    <app-subscription-table-mobile
      id="subscription-table"
      [identibasePlusButtonLabel]="'Learn more'"
      [identialertButtonLabel]="'Learn more'"
      [identifindButtonLabel]="'Buy now'"
      [buyButtonDisabled]="!hasIdentiFindOption && isAuthenticated"
      [findHighlighted]="true"
      [buyButtonVisible]="buyButtonVisible"
      (identitableButtonClicked)="onIdentitableButtonClicked($event)"
    ></app-subscription-table-mobile>
  </ng-template>
</div>
